import {post} from '@stubhub/rest-method';

import {TIME} from './utils/constant';

const noLogger = {
  info() {
    //
  },
  warn() {
    //
  },
  error() {
    //
  },
};
export const defaultLevel = 'info';

const weight = {
  trace: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
};

class RemoteLogger {
  constructor(meta = {}, level) {
    level = level && level.toLowerCase();
    this.meta = meta;
    this.level = (weight[level] && level) || defaultLevel;
    this.queue = [];
    this.timer;
  }

  flush() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      const q = this.queue.slice();
      this.queue = [];
      this.timer = null;
      post({path: `${process.env.REACT_APP_API_HOST}/logging`, body: q, json: true, logger: noLogger}).catch((e) => {
        console.error('RemoteLogger:', e); // eslint-disable-line
      });
    }, TIME.THOUSAND);
  }

  addToQueue(ob) {
    this.queue.push(ob);
  }

  l(level, ob) {
    /* istanbul ignore else: no need to do anything if nothing to log or level is lower */
    if (ob && weight[level] >= weight[this.level]) {
      /* istanbul ignore else */
      if (typeof ob === 'string') {
        ob = {message: ob};
      }
      ob.clientTS = Date.now();
      ob.level = level;
      this.addToQueue(ob);
      this.flush();
    }
  }

  info(ob) {
    return this.l('info', ob);
  }

  debug(ob) {
    return this.l('debug', ob);
  }

  trace(ob) {
    return this.l('trace', ob);
  }
  log(ob) {
    return this.l(this.level, ob);
  }

  warn(ob) {
    return this.l('warn', ob);
  }

  error(ob) {
    return this.l('error', ob);
  }
}

export default RemoteLogger;
export const logger = new RemoteLogger();
